import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class PlanSalesService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/plan_sales", { params: toSnakeCase(params) });
  }

  fetch(id, includes = []) {
    return securedAxiosInstance.get(`/plan_sales/${id}`, { params: { includes } });
  }

  update(planSaleId, formData) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleId}`, toSnakeCase(formData));
  }

  cancel(planSaleId, cancellation) {
    return securedAxiosInstance.put(`/plan_sales/${planSaleId}/cancel`, toSnakeCase(cancellation));
  }

  sendConfirmationEmail(planSaleId) {
    return securedAxiosInstance.post(`/plan_sales/${planSaleId}/send_confirmation`);
  }
}

export default new PlanSalesService();
